import { css, html, LitElement } from 'lit';
import { KryptonElement } from './krypton-element';

export class FormLayout extends KryptonElement {

    static styles = css`
        :host {
            display: -ms-grid;
            display: grid;
            padding: 2em 1em;
        }
    `;

    render() {
        return html`<slot></slot>`;
    }

}

export class FormRow extends LitElement {

    onSlotChange(e: Event) {
        const slot = this.shadowRoot?.querySelector("slot");
        const checkboxes: HTMLInputElement[] = slot?.assignedNodes().filter(n => n instanceof HTMLInputElement).filter(i => (i as HTMLInputElement).getAttribute("type") === "checkbox") as HTMLInputElement[];
        if (checkboxes && checkboxes.length) {
            checkboxes.forEach(c => {
                let div = document.createElement("div");
                div.appendChild(c);
                let sibling;
                if (sibling = c.nextElementSibling) {
                    this.insertBefore(div, sibling);
                } else {
                    this.appendChild(div);
                }
            });
        }
    }

    static styles = css`
        :host {
            display: -ms-grid;
            display: grid;
            -ms-grid-columns: 1fr 1fr;
            grid-template-columns: 1fr 1fr;
            margin-bottom: 1rem;
        }
    `;

    render() {
        return html`
        <slot @slotchange="${this.onSlotChange}"></slot>
        `;
    }

}

declare global {
    interface HTMLElementTagNameMap {
        'f-layout': FormLayout;
        'f-row': FormRow;
    }
}